import initialState from './initialState';

const reducers = {
  LOAD_NAICS_CODES_SUCCESS: (state, payload) => {
    return payload;
  },
  CLEAR_NAICS_CODES: () => {
    return [];
  }
};

export default function naicsCodes(state = initialState.naicsCodes, action) {
  let reducer = reducers[action.type];
  return (reducer ? reducer(state, action.naicsCodes) : state);
}



/** WEBPACK FOOTER **
 ** ./src/reducers/naicsReducer.js
 **/